import axios from 'axios';
import storage from 'store';

var apis = {
  base_url: '/api',
  serviceName: '/service-filemanagement',
  authLogin() {
    return this.base_url + '/auth/login';
  },
  getFolder() {
    return this.base_url + this.serviceName + '/diretory/tree';
  },
  addFolder() {
    return this.base_url + this.serviceName + '/diretory/add';
  },
  delFolder() {
    return this.base_url + this.serviceName + '/diretory/delete';
  },
  updateFolder() {
    return this.base_url + this.serviceName + '/diretory/update';
  },
  getFile() {
    return this.base_url + this.serviceName + '/file/page';
  },
  downFile() {
    return this.base_url + this.serviceName + '/file/downloadfile';
  },
  updateFile() {
    return this.base_url + this.serviceName + '/file/update';
  },
  delFile() {
    return this.base_url + this.serviceName + '/file/delete';
  },
  uploadFile() {
    return this.base_url + this.serviceName + '/file/uploadfile';xw
  },
  downloadFile(id) {
    return this.base_url + this.serviceName + '/file/download?id=' + id + `&access_token=${storage.get('access_token')}`;
  },
  getImages(id) {
    return this.base_url + this.serviceName + '/file/view/' + id + `?access_token=${storage.get('access_token')}`;
  },
  downloadFileAll(id) {
    return this.base_url + this.serviceName + '/file/downloadall?directoryId=' + id + `&access_token=${storage.get('access_token')}`;
  }
};
function isJSONArray(str) {
  if (typeof str == 'string') {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    if (Object.prototype.toString.call(JSON.parse(str)) === '[object Array]' && Object.prototype.toString.call(JSON.parse(str)).length >= 1) {
      return true;
    }
  }

  return false;
}
apis.isJSONArray = isJSONArray;

apis.createID = function(length) {
  return Number(
    Math.random()
      .toString()
      .substr(3, length) + Date.now()
  ).toString(36);
};

function http(object, isload = true) {
  let _this = this;
  // 局部注册组件
  isload && this.$load.show();
  let pase = {
    url: '',
    method: 'get',
    responseType: 'json'
  };
  pase = Object.assign(pase, object);
  let success = (response) => {
    object.success && object.success(response);
    return response;
  };
  let error = (error) => {
    isload && _this.$load.close();
    console.error(error);
    object.error && object.error(error);
    return error;
  };
  let complete = (complete) => {
    object.complete && object.complete(complete);
    _this.$nextTick(function() {
      isload && _this.$load.close();
    });
  };

  return axios(pase)
    .then(success)
    .catch(error)
    .then(complete);
}

export { apis, http };
